// ============================================================
// api/adminTenantIntegrations.js
// Endpoint bindings for the GLOBAL (cross-client) tenant-integrations
// operational surface (Phase 3 Stage 4 Phase 3b). Distinct from
// adminTenantSearch.js, which is per-client (clients/{id}/tenant-integration).
//
// Backend:
//   admin-tenant-integrations-list.js / admin-tenant-integrations-metrics.js
//   APIM operations: mgmt-admin-tenant-integrations-list / -metrics
//
// Both are read-only GETs that THROW an ApiError on non-2xx (the shared
// client.js contract — callers use translateError).
// ============================================================

import { apiGet } from './client';

/**
 * Global list of every client's tenant integration (Broad + Selected),
 * joined to Clients (clientName + isDemo). No pagination.
 * @returns {Promise<{ items: Array }>}
 */
export async function listTenantIntegrations() {
  return apiGet('/mgmt/admin/tenant-integrations');
}

/**
 * Global TenantSearchLog metrics over a trailing window.
 * @param {{ days?: number }} [opts]
 * @returns {Promise<{ windowDays: number, fromDate: string, perIntegration: Array, platformTotals: Object }>}
 */
export async function getTenantIntegrationsMetrics({ days = 7 } = {}) {
  return apiGet('/mgmt/admin/tenant-integrations/metrics', { days });
}
